import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import LoginScreen from '../screens/auth/LoginScreen';
import RegisterScreen from '../screens/auth/RegisterScreen';
import PasswordRecoveryScreen from '../screens/auth/PasswordRecoveryScreen';
import TermsConditionsScreen from '../screens/legal/TermsConditionsScreen';
import PrivacyPolicyScreen from '../screens/legal/PrivacyPolicyScreen';

export type AuthStackParamList = {
  Login: undefined;
  Register: undefined;
  PasswordRecovery: undefined;
  TermsConditions: undefined;
  PrivacyPolicy: undefined;
};

const Stack = createNativeStackNavigator<AuthStackParamList>();

export const AuthNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
      initialRouteName="Login"
    >
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="Register" component={RegisterScreen} />
      <Stack.Screen 
        name="PasswordRecovery" 
        component={PasswordRecoveryScreen} 
        options={{ headerShown: false }} 
      />
      <Stack.Screen 
        name="TermsConditions" 
        component={TermsConditionsScreen} 
        options={{ 
          headerShown: true,
          title: 'Términos y Condiciones',
          headerBackTitle: 'Atrás',
        }} 
      />
      <Stack.Screen 
        name="PrivacyPolicy" 
        component={PrivacyPolicyScreen} 
        options={{ 
          headerShown: true,
          title: 'Política de Privacidad',
          headerBackTitle: 'Atrás',
        }} 
      />
    </Stack.Navigator>
  );
}; 